import React from 'react';
import { format, parseISO } from 'date-fns';

export const CARD = 'bg-white rounded-xl border border-gray-200 shadow-sm';
export const INPUT =
  'rounded-md border border-gray-300 px-3 py-1.5 text-sm focus:border-claret-500 focus:outline-none focus:ring-1 focus:ring-claret-500';
export const PRIMARY =
  'rounded-md bg-claret-500 px-4 py-1.5 text-sm text-white hover:bg-claret-400 disabled:cursor-not-allowed disabled:opacity-50';
export const SECONDARY =
  'rounded-md border border-gray-300 bg-white px-4 py-1.5 text-sm text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50';

export const STUDENT_STATUSES = [
  { key: 'submitted', label: 'Submitted' },
  { key: 'in_progress', label: 'In progress' },
  { key: 'not_started', label: 'Not started' },
];

const FORM_STATUS = {
  open: { label: 'Open', style: 'bg-green-50 text-green-700' },
  scheduled: { label: 'Opens later', style: 'bg-amber-50 text-amber-700' },
  closed: { label: 'Closed', style: 'bg-gray-100 text-gray-600' },
};

export function FormStatusBadge({ status }) {
  const s = FORM_STATUS[status] || {
    label: status,
    style: 'bg-gray-100 text-gray-600',
  };
  return (
    <span
      className={`rounded-full px-2 py-0.5 text-[11px] font-medium ${s.style}`}
    >
      {s.label}
    </span>
  );
}

// A date picked in the browser (staff are in Kenya) means the end of that
// day in EAT (UTC+3), sent as UTC.
export const dueAtFromDay = (day) =>
  day ? new Date(`${day}T23:59:59+03:00`).toISOString() : null;

// Back to the EAT calendar day for the date input.
export const dayFromDueAt = (dueAt) =>
  dueAt
    ? new Date(new Date(dueAt).getTime() + 3 * 60 * 60 * 1000)
        .toISOString()
        .slice(0, 10)
    : '';

export const formatDue = (dueAt) => {
  if (!dueAt) return 'No due date';
  const day = dayFromDueAt(dueAt);
  return `Due ${format(parseISO(day), 'd MMM yyyy')}`;
};

export const formatDateTime = (value) =>
  value ? format(parseISO(value), 'd MMM yyyy, HH:mm') : '–';

// Submitted, in progress and not started as one bar.
export function ProgressBar({ counts }) {
  const members = counts?.members ?? 0;
  const pct = (n) => (members ? (100 * (n ?? 0)) / members : 0);
  return (
    <div className="space-y-1">
      <div
        className="flex h-2 w-full overflow-hidden rounded-full bg-gray-100"
        role="img"
        aria-label={`${counts?.submitted ?? 0} of ${members} submitted`}
      >
        <div
          className="bg-green-500"
          style={{ width: `${pct(counts?.submitted)}%` }}
        />
        <div
          className="bg-amber-400"
          style={{ width: `${pct(counts?.in_progress)}%` }}
        />
      </div>
      <p className="text-[11px] text-gray-500">
        {(counts?.submitted ?? 0).toLocaleString()} of{' '}
        {members.toLocaleString()} submitted
        {counts?.in_progress
          ? ` · ${counts.in_progress.toLocaleString()} in progress`
          : ''}
      </p>
    </div>
  );
}
